module.exports = __webpack_public_path__ + "img/hotdish.3932ec1c.png";